import styled from 'styled-components';
import { GridRow } from 'ui/indexPages/tables/grid';
import { spacing } from 'ui/theme';

export const SkeletonGridRow = styled(GridRow)`
  padding: ${spacing.half} ${spacing.double};
`;
